"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealthIndication = void 0;
const investor_type_enum_1 = require("../../@types/incoming/enum/investor-type.enum");
class HealthIndication {
    constructor(investorType) {
        this.investorType = investorType;
    }
    getIndication(data) {
        let qntBuy = 0;
        let qntSell = 0;
        let qntNeutral = 0;
        const indications = [
            this.getScoreIndication(data.CashFlow),
            this.getScoreIndication(data.Growth),
            this.getScoreIndication(data.Momentum),
            this.getScoreIndication(data.Profit),
            this.getScoreIndication(data.RelativeValue),
        ];
        indications.forEach((indication) => {
            switch (indication) {
                case 'BUY':
                    qntBuy++;
                    break;
                case 'NEUTRAL':
                    qntNeutral++;
                    break;
                case 'SELL':
                    qntSell++;
                    break;
            }
        });
        const output = {
            summary: {
                qntBuy: this.investorType === investor_type_enum_1.eInvestorType.BUY_AND_HOLDER
                    ? qntBuy * 3
                    : qntBuy,
                qntSell: this.investorType === investor_type_enum_1.eInvestorType.BUY_AND_HOLDER
                    ? qntSell * 3
                    : qntSell,
                qntNeutral,
            },
            internalPoints: qntBuy,
        };
        return output;
    }
    getScoreIndication(score) {
        const actual = score.Actual;
        if (actual >= 8) {
            return 'BUY';
        }
        else if (actual <= 4) {
            return 'SELL';
        }
        return 'NEUTRAL';
    }
}
exports.HealthIndication = HealthIndication;
//# sourceMappingURL=health-indication.js.map